export * from './web-component-wrapper.props';
export * from './web-component-wrapper';
